export type TIdsMap = {
    [id: number]: number[]
}

export enum EMapUpdateType {
    ADD = 'ADD',
    REMOVE = 'REMOVE'
}
